import { render, staticRenderFns } from "./report-mb.vue?vue&type=template&id=87818c28&"
import script from "./report-mb.vue?vue&type=script&lang=js&"
export * from "./report-mb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "report-mb.vue"
export default component.exports